export default "__VITE_ASSET__Dk2RMi9Q__"